import { render } from "./PricePartApp.vue?vue&type=template&id=522d64b1&scoped=true"
const script = {}

import "./PricePartApp.vue?vue&type=style&index=0&id=522d64b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-522d64b1"]])

export default __exports__